// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"917d0db7","453":"aa98284a"}[chunkId] + ".chunk.js";
};